import { Link } from "react-router-dom"
import styled from "styled-components"

import { Flex, Typography } from "components/common"

export const GemTitle = styled(Typography).attrs({
  as: "h1",
  fontSize: 35,
  fontWeight: 700,
  mb: 2,
  px: { _: 5, tablet: 0 },
})``

export const GemText = styled(Typography).attrs((props) => ({
  fontSize: 18,
  mb: 5,
  px: { _: 4, desktop: "220px", tablet: 8 },
  ...props,
}))``

export const GemContainer = styled(Flex).attrs((props) => ({
  alignContent: "flex-start",
  flexWrap: "wrap",
  justifyContent: { _: "center", tablet: "flex-start" },
  margin: "auto",
  width: { _: "90%", desktop: "75%" },
  ...props,
}))``

export const GemLink = styled(Typography).attrs({
  as: Link,
  color: "primary",
})`
  text-decoration: underline;
`
